export default "__VITE_ASSET__hwQDYY9z__"